import { render, staticRenderFns } from "./GlobalFilter.vue?vue&type=template&id=37707018&scoped=true&"
import script from "./GlobalFilter.vue?vue&type=script&lang=js&"
export * from "./GlobalFilter.vue?vue&type=script&lang=js&"
import style0 from "./GlobalFilter.vue?vue&type=style&index=0&id=37707018&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37707018",
  null
  
)

export default component.exports